import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { NBAGameListItem } from "../../../../../util/types";
import { NBA_TEAMS } from "../../../../../data/teams";
import { getTeamLogoUrl } from "../../../../../models/Team";
import { PORTLAND_TEAM_ID } from "../constants";

export default function GameHeader({
  game,
  gameNumber,
}: {
  game: NBAGameListItem;
  gameNumber: number;
}) {
  const isHome = game.homeTeam.teamId === PORTLAND_TEAM_ID;
  const opponent = isHome ? game.awayTeam : game.homeTeam;
  const team = NBA_TEAMS.find((t) => t.nbaId === opponent.teamId);
  const teamCity = team?.city ?? "";
  const teamName = team?.name ?? opponent.teamName;
  const formattedDate = dayjs(game.gameDateEst.split("T")[0]).format("MMM D");
  const teamLogoUrl = team ? getTeamLogoUrl(team) : "";

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      gap={1}
      sx={{
        position: "relative",
        overflow: "hidden",
        mb: 2,
        "@media print": { mb: 8 },
      }}
    >
      <img
        src={teamLogoUrl}
        alt={opponent.teamName}
        style={{
          height: 170,
          width: 170,
          position: "absolute",
          left: 220,
          top: -30,
          opacity: 0.3,
          zIndex: 0,
        }}
      />

      <Stack alignItems="flex-end" sx={{ zIndex: 1, mt: "3px" }}>
        <Typography variant="overline" lineHeight={1} sx={{ fontSize: 12 }}>
          {formattedDate}
        </Typography>
        <Typography
          variant="h3"
          fontWeight={700}
          lineHeight={1}
          sx={{ textAlign: "right" }}
        >
          G{gameNumber}
        </Typography>
        <Typography variant="h4" lineHeight={1} sx={{ textAlign: "right" }}>
          {isHome ? "vs" : "@"}
        </Typography>
      </Stack>

      <Stack
        sx={{
          zIndex: 1,
          ml: 1,
          ".MuiTypography-root": { fontFamily: "Roboto Condensed" },
        }}
      >
        <Typography variant="h2" fontWeight={300} lineHeight={1}>
          {teamCity}
        </Typography>
        <Typography
          fontSize="4.5rem"
          fontWeight={700}
          lineHeight={1}
          textTransform="uppercase"
          sx={{ mt: -0.5 }}
        >
          {teamName}
        </Typography>
      </Stack>
    </Stack>
  );
}
